const ORGANIZATION_MEMBERSHIP_ROLE = {
  ADMIN: 'admin',
  AUTHOR: 'author',
  CHATTER: 'chatter',
};

export default ORGANIZATION_MEMBERSHIP_ROLE;
